module.exports = "/images/QSG-Laptop.jpg";